module.exports = __webpack_public_path__ + "static/media/blueVert.8fcec8c3.png";